
import { getLink } from '../../../utils/utils';
import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
    
        <p class="mb-3 text-center bold">* * *</p>

        <p class="poem-block mb-3">
            Kiel min karesis destino!<br/>
            Kaj atendis mi en fascino,<br/>
            Ke senĉese daŭros la ĝojo<br/>
            Plu ascendi laŭ glata vojo!
        </p>

        <p class="poem-block mb-3">
            Sed severas geometrio:<br/>
            Jam malsupras la kurba linio<br/>
            Kaj post longa peniga falo<br/>
            Forblovita de l’ piedestalo,<br/>
            Trafis mi al haven’ kvieta,<br/>
            Al azilo paca poeta.
        </p>

        <p class="poem-block mb-3">
            Jen laŭ lanta muzik’ de Andante<br/>
            Vidas mi: proksimiĝas Dante.<br/>
            Do atendas min la Infer’,<br/>
            Sed ne hel-paradiza sfer’.
        </p>

        <p class="poem-block mb-5">
            Nu, ni iru antaŭen plu,<br/>
            Simple laŭ la kuranta flu’,<br/>
            Kien gvidas nin la destin’<br/>
            Nur antaŭen, ĝis lasta fin’!
        </p>


    
        <p class="mb-3 text-center bold">* * *</p>

        <p class="poem-block mb-3">
            Animon premas sent’,<br/>
            Sed dum la suno helas,<br/>
            Dum povas spiri ni kaj kanti en plenfort’,<br/>
            Ni kantos pri la suno kaj ĉielo,<br/>
            Nur tiel – ĝis la mort’!
        </p>

        <p class="poem-block mb-3">
            Animon premas sent’,<br/>
            Kiam krepuskoj bluaj<br/>
            Densiĝas plu dum kurtas la aŭror’,<br/>
            Someran varmon pala lun’ diluas<br/>
            Kaj pli senteble nokte vento bruas,<br/>
            Siblante tra branĉar’ laŭ vintra morna mor’.
        </p>

        <p class="poem-block mb-5">
            Animon premas sent’,<br/>
            Sed dum la suno helas,<br/>
            Dum povas spiri ni kaj kanti en plenfort’,<br/>
            Ni kantos pri la suno kaj ĉielo,<br/>
            Nur tiel – ĝis la mort’!
        </p>

        
        <p class="mb-3 text-center bold">* * *</p>

        <p class="poem-block mb-3">
            La lingvo bela Esperanto,<br/>
            Mirinda ido de l’ homar’,<br/>
            Ja sonas vi kiel belkanto,<br/>
            Sonet’ perfekta, sen erar’!<br/>
            Vi – la insul’ de lum’ kaj bono,<br/>
            Al ni donita por dispono,<br/>
            Vi estas varma nia dom’,<br/>
            Kie bonvenas ĉiu hom’.<br/>
            Per granda rev’ unuigitaj<br/>
            Ke ekkomprenu fraton frat’<br/>
            Ni staru kune, sen debat’<br/>
            Por la valoroj altspiritaj.
        </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Infanaj poemetoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;